<template>
  <div ref="draggable" class="h-full relative w-full DragDblClick z-[1] flex items-center justify-center">
    <svg xmlns="http://www.w3.org/2000/svg" width="31.819" height="31.819" viewBox="0 0 31.819 31.819">
      <g id="Group_9" data-name="Group 9" transform="translate(1203 1599)">
        <path id="Subtraction_2" data-name="Subtraction 2"
          d="M29.7,31.819h0L21.879,24H24V21.879L31.819,29.7,29.7,31.819ZM8,10.121l0,0-8-8L2.121,0l8,8H8v2.121Z"
          transform="translate(-1203 -1599)" fill="#fff" />
        <path id="Subtraction_1" data-name="Subtraction 1"
          d="M2.121,31.819h0L0,29.7l8-8V24h1.94L2.122,31.819ZM24,9.94V8H21.7l8-8,2.121,2.121L24,9.939Z"
          transform="translate(-1203 -1599)" fill="#fff" />
      </g>
    </svg>
  </div>
</template>

<script>
import { ref } from 'vue';
import { GamepadListener } from 'gamepad.js';
import { toast } from "vue3-toastify";
import API from '@/utils/API.js';

export default {
  name: "DragDblClick",
  props: {
    config: Object,
    video: Object,
  },
  setup() {
    return {
      draggable: ref(null),
      gamepadListener: ref(false),
      gamepad: ref(false),
      clock: ref(0),
      currentZoom: ref(0),

      // ----

      xRepeatID: ref(null),
      yRepeatID: ref(null),
      zoomRepeatID: ref(null),
    };
  },

  mounted() {
    this.initDbclick();
    this.initGamepad();

    if (this.config?.camera?.status?.video_type == 'ir') {
      this.currentZoom = this.config?.camera?.status?.ir_zoom_factor
    }
    else if (this.config?.camera?.status?.video_type == 'zoom') {
      this.currentZoom = this.config?.camera?.status?.zoom_factor
    }
  },

  unmounted() {
    if (this.gamepadListener !== false) {
      this.gamepadListener.stop();
    }
  },

  methods: {
    initDbclick() {
      this.draggable.addEventListener('dblclick', (e) => {
        e.preventDefault();

        let parentRect = this.draggable.parentElement.getBoundingClientRect();

        let left = e.clientX - parentRect.x;
        let top = e.clientY - parentRect.y;

        // let div = document.createElement('div');
        // div.style.position = 'absolute';
        // div.style.top = top + 'px';
        // div.style.left = left + 'px';
        // div.style.width = '5px';
        // div.style.height = '5px';
        // div.style.background = 'red';
        // div.style.zIndex = '999999';
        // e.srcElement.parentElement.appendChild(div);

        left = left - (parentRect.width / 2);
        top = top - (parentRect.height / 2);

        left = left / (parentRect.width / 180);
        top = top / (parentRect.height / 180);

        this.camerascreendrag(left, top);
      });
    },

    initGamepad() {
      var baseValue = 20;
      var deadzone = 0.92;

      this.$root.controller.gamepadToAction = {
        'AXE': {
          '0': {
            clock: 5,
            action: (value) => {
              if (value == 0) {
                clearInterval(this.xRepeatID);
                return;
              }

              if (value > deadzone || value < -deadzone) {
                if (this.xRepeatID !== null) return;

                this.xRepeatID = setInterval(() => {
                  if (this.xRepeatID !== null) {
                    this.camerascreendrag(value * baseValue, 0);
                  }
                  else {
                    clearInterval(this.xRepeatID);
                  }
                }, 500);
              }
              else {
                clearInterval(this.xRepeatID);
                this.xRepeatID = null;
                this.camerascreendrag(value * baseValue, 0);
              }
            },
          },
          '1': {
            clock: 5,
            action: (value) => {
              if (value == 0) {
                clearInterval(this.yRepeatID);
                return;
              }

              if (value > deadzone || value < -deadzone) {
                if (this.yRepeatID !== null) return;

                this.yRepeatID = setInterval(() => {
                  if (this.yRepeatID !== null) {
                    this.camerascreendrag(0, value * baseValue);
                  }
                  else {
                    clearInterval(this.yRepeatID);
                  }
                }, 500);
              }
              else {
                clearInterval(this.yRepeatID);
                this.yRepeatID = null;
                this.camerascreendrag(0, value * baseValue);
              }
            },
          },
          '2': {
            clock: 5,
            action: (value) => {
              if (value == 0) {
                clearInterval(this.zoomRepeatID);
                return;
              }

              if (value > deadzone || value < -deadzone) {
                if (this.zoomRepeatID !== null) return;

                this.zoomRepeatID = setInterval(() => {
                  if (this.zoomRepeatID !== null) {
                    this.zoom(value);
                  }
                  else {
                    clearInterval(this.zoomRepeatID);
                  }
                }, 500);
              }
              else {
                clearInterval(this.zoomRepeatID);
                this.zoomRepeatID = null;
                this.zoom(value);
              }
            },
          }
        },
        'BUTTON': {
          '0': {
            action: (value) => { },
          },
          '1': {
            action: (value) => { },
          }
        }
      }
    },



    async camerascreendrag(x, y) {
      let data = await API.put(`camerascreendrag`, {
        DevId: this.config.deviceFamilly.this_dev_id,
        CamId: this.config.camera.payload_index,
        CamType: this.config.camera.status.video_type,
        Yawsp: x,
        Pitsp: -y,
        Locked: true,
      });
    },

    async zoom(value) {
      this.currentZoom += (value * 3)

      let data = await API.put(`camerafocallengthset`, {
        DevId: this.config.deviceFamilly.this_dev_id,
        CamId: this.config.camera.payload_index,
        CamType: this.config.camera.status.video_type,
        Factor: this.currentZoom
      });
    },
  },

  watch: {
    'config.camera.status.video_type': {
      handler(val, oldVal) {
        if (val != oldVal) {
          if (val == 'ir') {
            this.currentZoom = this.config?.camera?.status?.ir_zoom_factor;
          }
          else if (val == 'zoom') {
            this.currentZoom = this.config?.camera?.status?.zoom_factor;
          }
        }
      },
      deep: true,
    },

    'config.full_screen_active': {
      handler: function (val) {
        if (val) this.initGamepad();
      },
    }
  }
};
</script>
